<template>
    <div
        v-if="progress !== null"
        class="w-[320px] rounded-[6px] border border-gray-200 bg-white p-4 shadow-lg"
        role="status"
        aria-live="polite"
    >
        <div class="flex items-center justify-between gap-2">
            <span class="text-sm font-medium text-gray-600">{{ label }}</span>
            <span class="text-sm text-gray-400">{{ percentage }}%</span>
        </div>

        <div class="mt-3 h-2 w-full overflow-hidden rounded-full bg-gray-200">
            <div
                class="h-2 rounded-full bg-topol-blue-500 transition-all duration-300 ease-out"
                :style="{ width: percentage + '%' }"
            ></div>
        </div>

        <p
            v-if="progress.phase === 'preparing'"
            class="mt-2 text-xs leading-normal text-gray-500"
        >
            They are already in Lettr. This is Lettr rendering them, which has
            to finish before they can be sent.
        </p>
    </div>
</template>

<script lang="ts" setup>
import useLettrExportProgress from '../composables/useLettrExportProgress';

const { progress, label, percentage } = useLettrExportProgress();
</script>
